import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog55/image1.png";
import image6 from "../../../../assets/images/Blog55/image6.png";
import image10 from "../../../../assets/images/Blog55/image10.png";
import image34 from "../../../../assets/images/Blog55/image34.png";
import image37 from "../../../../assets/images/Blog55/image37.png";
import image76 from "../../../../assets/images/Blog55/image76.png";
import image22 from "../../../../assets/images/Blog55/image22.png";
import image70 from "../../../../assets/images/Blog55/image70.png";
import image41 from "../../../../assets/images/Blog55/image41.png";
import image43 from "../../../../assets/images/Blog55/image43.png";
import image101 from "../../../../assets/images/Blog55/image101.png";
import image45 from "../../../../assets/images/Blog55/image45.png";
import image79 from "../../../../assets/images/Blog55/image79.png";
import image82 from "../../../../assets/images/Blog55/image82.png";
import image84 from "../../../../assets/images/Blog55/image84.png";
import image95 from "../../../../assets/images/Blog55/image95.png";
import image99 from "../../../../assets/images/Blog55/image99.png";
import image89 from "../../../../assets/images/Blog55/image89.png";
import image104 from "../../../../assets/images/Blog55/image104.png";
import image102 from "../../../../assets/images/Blog55/image102.png";
import image36 from "../../../../assets/images/Blog55/image36.png";

const Blog55 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – February 9, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Rotation Intensifies, Volatility Returns</p>

        <p>
          Markets enter the new week after a sharp reminder that leadership transitions are rarely quiet. What began as a continued rotation away from richly valued technology has evolved into a
          broader repricing of positioning, volatility, and cross-asset conviction. Systematic flows are driving price action while sector dispersion has widened across indices.
        </p>
        <p>
          Short-gamma positioning has amplified recent price swings. Systematic selling pressure, short-gamma positioning, and elevated margin constraints have amplified swings, even as headline
          indices remain structurally supported. Recent volatility expanded alongside positioning resets in crowded trades.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Rotation Without Structural Damage</p>

              <p>
                Equity structure remains intact while sector leadership has shifted. Technology multiples compressed as industrial and value sectors stabilised, resulting in wider performance
                dispersion without a breakdown in headline indices. The Dow’s breakout occurred alongside this internal rotation, reflecting divergence in sector performance rather than broad risk
                reduction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="DOW50k"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Pressure inside software and AI-linked names coincided with multiple compressions relative to other sectors. Earnings expectations remained comparatively stable while price performance
                diverged, reinforcing that recent moves reflect valuation adjustment rather than earnings deterioration. Sector dispersion increased, consistent with a market trading on rotation
                rather than synchronised momentum.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Anthropic software smash"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt="dispersion = market of stocks"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Volatility expanded alongside short-gamma positioning, increasing sensitivity to directional price swings. Relief rallies followed the volatility reset without altering the broader
                index structure, indicating that positioning adjustments — rather than structural breakdown — defined the week’s movement.
              </p>
              <div className="relatedImg">
                <img
                  src={image37}
                  alt="Volatility easing late in the week"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image37)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Recent price action reflects sector rotation and positioning-driven dispersion while headline index structure remains intact. Leadership divergence widened, consistent with an
                environment shaped by valuation resets and flow dynamics.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Politics, Liquidity, and Rate Sensitivity</p>
              <p>
                Cross-asset price action coincided with shifts in yields and currency markets during the week. Bond yields moved higher alongside broader asset volatility, reflecting rate-sensitive
                positioning rather than changes in earnings structure. Rate-sensitive assets reacted to these yield movements without altering the overall index structure.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image76}
                    alt="yields lower last week"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image76)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Japan’s election outcome was followed by equity strength, higher yields, and currency volatility. Portions of that initial move retraced later in the week, leaving cross-asset pricing
                aligned with positioning adjustments rather than a persistent directional shift. The sequence reflects how political developments coincided with rate and currency sensitivity across
                markets.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="Japan election result"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Corporate capital allocation trends showed elevated capital expenditure relative to shareholder returns. The technology sector multiples adjusted alongside this shift while earnings
                expectations remained comparatively stable, reinforcing that valuation dispersion occurred independently of earnings deterioration.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="capex v fcf"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Commodity markets reflected positioning and liquidity adjustments during the repricing phase. Metals and resource-linked assets traded with elevated volatility consistent with
                cross-asset flow activity rather than a breakdown in underlying structure.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image70}
                    alt="3rd wave of Gold supremacy over the dollar"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image70)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                Headline indices remained within broader uptrends while internal performance diverged. Sector dispersion widened alongside changes in positioning, reflecting uneven participation
                across industries rather than synchronised index momentum.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="strong breadth = 6–12 month gains"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <p>
                  Systematic positioning influenced directional price swings as short-gamma exposure increased volatility sensitivity. Volatility-linked flows accelerated during the repricing phase,
                  followed by relief rallies consistent with positioning resets rather than structural trend changes.
                </p>
                <div className="relatedImg">
                  <img
                    src={image43}
                    alt="GS panic index turned on"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image43)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Crypto and metals experienced liquidation phases followed by stabilisation, aligning with cross-asset positioning adjustments. Price action reflected flow-driven unwinds rather than
                earnings or structural deterioration.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image101}
                    alt="crypto took a beating across the board"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image101)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Volatility control activity and positioning flows remained active after the reset, reinforcing that recent movement was driven by mechanical exposure adjustments rather than
                directional trend continuation.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt=" Volatility Control flows poised to sell on VIX pop"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Rotation Shock, Volatility Reset</p>
              <p>Last week illustrated how quickly positioning and liquidity conditions can reshape leadership without breaking the broader market structure.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Bond yields pushed higher amid fiscal and political sensitivity, tightening financial conditions at the margin. Markets interpreted this less as growth deterioration and
                    more as liquidity friction, reinforcing volatility across risk assets.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image76}
                        alt="yields lower last week"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image76)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Seasonal demand shifts around the Lunar holiday appeared to influence metals flows, particularly copper, highlighting how regional activity changes can ripple into global
                    commodity pricing.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image79}
                        alt="across the board metals smash"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image79)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Forward expectations for major growth sectors remained broadly stable despite price volatility. The disconnect between earnings resilience and multiple compression
                    underscores that valuation adjustment, not earnings collapse, is driving performance dispersion.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Gold and silver volatility reflected physical market dynamics colliding with futures positioning and margin pressures. The pricing disconnect between regional trading
                    venues reinforced liquidity sensitivity.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image82}
                      alt="gold and silver volatility still extended"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image82)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image84}
                      alt="gold rallies in context"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image84)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Crypto experienced a broad liquidation phase consistent with deleveraging and sentiment washout. Stabilisation late in the week suggests forced selling rather than
                    structural abandonment.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image95}
                      alt="Friday's BTC bounce post forced selling boost"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image95)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image99}
                      alt=" looking for divergence now at the bottom"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image99)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy markets remained range-bound as supply commentary and geopolitical considerations balanced demand concerns, reinforcing consolidation rather than directional
                    conviction.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image89}
                        alt="oil backinto downtrend?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image89)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                This week clusters labour market releases, inflation data, consumer activity, and central bank communication, a mix that directly shapes rate expectations and liquidity conditions.
                With positioning already sensitive, the concentration of macro catalysts increases the probability of volatility bursts rather than isolated reactions.
              </p>
              <p className="highlightedText">Monday, February 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span>Economy Watchers Current Index
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span> Sentix Investor Confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> CB Employment Trends Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">ECB:</span> Lagarde speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed: </span> Waller speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Treasury Bill Auctions
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, February 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Core Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Employment Cost Index
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> ADP Employment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed: </span> Logan speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> 3-Year Treasury Auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, February 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span> CPI
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Nonfarm Payrolls
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Average Hourly Earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed: </span> Bowman speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> Cisco Systems
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> 10-Year Treasury Auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, February 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK: </span> GDP (Monthly & Quarterly)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Initial Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Existing Home Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">ECB: </span> Cipollone speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Alibaba
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, February 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Core CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> GDP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span>CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">BoE: </span> Pill speaks
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image104}
                    alt="US data this week"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image104)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image102}
                    alt="EW 090226"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image102)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Rotation Continues, Discipline Matters</p>
              <p>
                Markets remain structurally supported, but leadership transition and volatility dynamics are redefining participation. Liquidity sensitivity, not macro collapse, is driving the tape.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Rotation away from concentrated growth toward industrial and value exposures continues. Structure holds, but volatility favours selective positioning over broad beta.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Metals remain volatile amid physical demand signals and futures positioning adjustments. Pricing swings reflect
                    liquidity dynamics more than structural trend change.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Liquidation appears driven by positioning washout. Stabilisation suggests a tactical reset phase rather than renewed
                    momentum.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Rate pressure, political developments, and systematic flows are shaping near-term price action. Liquidity conditions
                    remain the dominant transmission channel.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                The market is not breaking; it is repricing participation. Elevated volatility is a reminder that structural support does not eliminate tactical risk, and disciplined exposure matters
                most when flows drive the narrative.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image36}
                    alt="at volatility extremes in high beta tech last week"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image36)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image70}
                    alt="3rd wave of Gold supremacy over the dollar"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image70)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image101}
                    alt="crypto took a beating across the board"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image101)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1_yhIREH14LUsZmHejsJgnVlqDopSx839MMFwNxfqk7g/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>

      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog55;
